//@flow
import React from 'react';
import {Link} from 'react-router-dom';
import {makeStyles} from '@material-ui/core';

import {HOME_PAGE_SECTION_NAMES} from '../../../utils/home-page-sections/constants';
import SwitchableSection from '../../../../../elements/SwitchableSection';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';
import {useBlogPostList} from '../../../../blog/utils/blog-post';
import {colors} from '../../../../../assets/styles/colors';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.75rem',
  },
  disabledRoot: {
    background: colors.grey300,
  },
}));

type Props = {
  sectionEnabled?: boolean,
};

export default function BlogSection(props: Props) {
  const {sectionEnabled} = props;
  const classes = useStyles();

  const blogPosts = useBlogPostList();
  const emptyContent = !blogPosts.some(post => post.featured);

  return (
    <SwitchableSection
      id={HOME_PAGE_SECTION_NAMES.BLOG}
      title="Sección de blog"
      subtitle="Muestra las fotos que subes a instagram en tu página de inicio."
      classes={{
        root: emptyContent || !sectionEnabled ? classes.disabledRoot : '',
      }}
    >
      <CustomButton
        className={classes.button}
        variant="contained"
        component={Link}
        target="_blank"
        rel="noopener noreferrer"
        to="/my-store/blog"
      >
        Ir a la seción de blog
      </CustomButton>
      {/*  <div className={classes.container}>
        <Typography variant="subtitle2">Blog Destacado</Typography>
        <CustomTextField type="text" label="Seleccionar Blog Destacado" />

        <Typography id="demo-radio-buttons-group-label" variant="subtitle2">
          Blogs Adicionales
        </Typography>
        <FormControl>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            name="radio-buttons-group"
            defaultValue="CUSTOM_SELECT"
          >
            <FormControlLabel
              value="LAST_FOUR"
              control={<Radio color="primary" />}
              label="Mostrar los últimos 4 blogs más recientes"
            />
            <FormControlLabel
              value="CUSTOM_SELECT"
              control={<Radio color="primary" />}
              label="Seleccionar los blogs que quieres mostrar"
            />
          </RadioGroup>
        </FormControl>
      </div> */}
    </SwitchableSection>
  );
}
